import React from 'react'

import MainNavButton from 'modules/Layout/shared/MainNavButton/index'

const DashboardMainNavButton = () => (
  <MainNavButton iconClass="fa fa-th-large fa-2x" to="/dashboard">
    Dashboard
  </MainNavButton>
)
export default DashboardMainNavButton
